module.exports = __webpack_public_path__ + "img/Connect_App@3x.df52b63a.png";